/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "28ea86c39ca96f945d73c1c00e472e13737c8a0c";
